import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MessageDTO } from '@sb-tools/typescript/models/dto/message.dto';
import { EncodeHtmlSymbolsPipe } from '@sb-tools/typescript/pipes/encode-html-symbols.pipe';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'hideContent' })
export class HideContentPipe implements PipeTransform {
    constructor(private encodeHtmlSymbolsPipe: EncodeHtmlSymbolsPipe) {}

    transform(message: MessageDTO): MessageDTO {
        if (message.html) {
            return message;
        }
        const regExp = new RegExp('{HiddenContent:((.*?)(?<!\\\\))}', 'g');
        message.html = this.encodeHtmlSymbolsPipe.transform(message.text).replace(regExp, (expression, hiddenText) => {
            return '<span class="sb-hidden-content-part">' + hiddenText + '</span>';
        });
        return message;
    }
}
